import { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../firebase';

const AuthContext = createContext(null);

function getCachedUser() {
  try {
    const s = localStorage.getItem('sa_user');
    return s ? JSON.parse(s) : undefined;
  } catch { return undefined; }
}

function getCachedRole() {
  return localStorage.getItem('sa_role') || null;
}

async function fetchRole(uid) {
  try {
    const base = process.env.REACT_APP_API_URL || 'http://localhost:8080';
    const res = await fetch(`${base}/api/admin/my-role?uid=${uid}`);
    if (!res.ok) return 'USER';
    const data = await res.json();
    return data.role || 'USER';
  } catch { return 'USER'; }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getCachedUser);
  const [role, setRole] = useState(getCachedRole);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      setUser(u ?? null);
      if (u) {
        localStorage.setItem('sa_user', JSON.stringify({ uid: u.uid, displayName: u.displayName, email: u.email, photoURL: u.photoURL }));
        // Registrar/actualizar usuario en BD (silencioso)
        fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/api/users/register`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ uid: u.uid, email: u.email, displayName: u.displayName, photoUrl: u.photoURL }),
        }).catch(() => {});
        const r = await fetchRole(u.uid);
        setRole(r);
        localStorage.setItem('sa_role', r);
      } else {
        localStorage.removeItem('sa_user');
        localStorage.removeItem('sa_role');
        setRole(null);
      }
    });
    return unsub;
  }, []);

  const logout = () => signOut(auth);

  return (
    <AuthContext.Provider value={{ user, role, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
